'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Dialog = _styledComponents2.default.div(_templateObject);

exports.default = Dialog;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/helpers/dialog.js
// module id = 250
// module chunks = 0